export default "__VITE_ASSET__ab0d85d2__"